module.exports = __webpack_public_path__ + "img/1572574554.aa82dd8a.jpg";